<!-- 转账 - 新增 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container add-transfer">
      <el-form ref="addRef" :rules="rules" :model="addObj" label-width="160px" size="mini">
      <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
      <!-- 账户类型 -->
      <el-form-item :label="$t('fi.lable.account.type')+ ':'">
        <el-select v-model="addObj.actype" clearable style="width: 20%" @change="getSum">
          <el-option v-for="item in actypeList" :key="item.code" :label="$lt(initDict.actype, item.code)" :value="item.code" />
        </el-select>
      </el-form-item>
        <!-- 余额 -->
        <el-form-item :label="$t('pmEfuboCard.balance')+ ':'">
          <span style="color: #ff0021; font-size: large">{{ balance }}&nbsp;</span>
          <span v-if="addObj.actype === 'F$'" style="color: #ff0021; font-size: large">$</span>
        </el-form-item>
        <!-- 收款方用户编号 -->
        <el-form-item :label="$t('FiAcTrans.inUserCode')+ ':'" prop="inUserCode">
          <el-input v-model.trim="addObj.inUserCode"  clearable @blur="inUserCodeBlur($event)" style="width: 20%" />
          <span v-if="blurYes" style="color: #ff0021; font-size: medium; margin-left: 6px">{{ memberNoBlur }}</span>
          <span v-else-if="blurNo" style="color: #ff0021; font-size: medium; margin-left: 6px">{{ $t('exist.user.ac.in.no') }}</span>
        </el-form-item>
        <!-- 付款金额 -->
        <el-form-item :label="$t('fi.pay.money')+ ':'" prop="outMoney">
          <el-input v-model.trim="addObj.outMoney"  clearable readonly onfocus="this.removeAttribute('readonly')" style="width: 20%" />
          <span v-if="addObj.actype === 'F$'" style="color: #67a05b;">&nbsp;$</span>
        </el-form-item>
<!--        <el-form-item v-if="addObj.outMoney && addObj.actype === 'F$'" :label="$t('本位币')+ ':'">-->
<!--          <span>{{ rateToUsd * Number(addObj.outMoney) }}</span>-->
<!--          <span style="color: red;">&nbsp;{{ $symbol() }}</span>-->
<!--        </el-form-item>-->
        <!-- 请输入您的支付密码 -->
        <el-form-item :label="$t('please.input.your.pay.password')+ ':'" prop="payPassword">
          <el-input show-password v-model.trim="addObj.payPassword" readonly onfocus="this.removeAttribute('readonly')" clearable style="width: 20%" />
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('poReturn.createRemark')+ ':'">
          <el-input type="textarea" :rows="3" v-model="addObj.memo" style="width: 30%" />
        </el-form-item>
      </el-form>
      <div style="text-align: center; margin-bottom: 10px">
        <el-button type="primary" :loading="saveLoading" @click="addSaveBtn">{{ $t('button.save') }}</el-button>
        <el-button icon="el-icon-close" @click="closeBtn">{{ $t('operation.button.cancel') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { balanceSum } from "@/api/member"
import { saveOrUpdateFiAcTrans } from "@/api/ay-account-manager"
import { mapGetters } from "vuex"
import { getPersonInfo } from "@/api/home"

export default {
  name: "AddTransfer",
  data() {
    return {
      rateToUsd: 0,
      blurYes: false,
      blurNo: false,
      memberNoBlur: '',
      balance: '',
      saveLoading: false,
      addObj: {
        actype: 'F$',
        inUserCode: '',
        outMoney: '',
        payPassword: '',
        memo: ''
      },
      initDict: {
        actype: 'fiacinput.actype.cn'
      },
      rules: {
        inUserCode: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        outMoney: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        payPassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}]
      }
    }
  },
  computed: {
    actypeList() {
      return this.$ll(this.initDict.actype).filter(ele => ele.code === 'F$' ||  ele.code === 'H0')
    },
    ...mapGetters([
      'language',
      'userCode',
        'isAgent'
    ]),
  },
  created() {
    this.getSum()
  },
  methods: {
    inUserCodeBlur(val) {
      this.memberNoBlur = ''
      if (val.target.value) {
        getPersonInfo({'userCode':val.target.value}).then(res=>{
          this.memberNoBlur = res.data.userName
          this.blurYes = true
          this.blurNo = false
        }).catch(err=>{
          this.blurYes = false
          this.blurNo = true
          console.error(err)
        })
      } else {
        this.blurYes = false
        this.blurNo = false
      }
    },
    addSaveBtn() {
      this.saveLoading = true
      this.$refs['addRef'].validate((valid) => {
        if (valid) {
          saveOrUpdateFiAcTrans({...this.addObj}).then(() => {
            this.$router.back()
            this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
            this.saveLoading = false
            this.resetForm('addRef')
          }).catch(err => {
            console.error(err)
            this.saveLoading = false
            this.$message.error(this.$t('bdSendRegister.operaterFail'))
          })
        } else {
          this.saveLoading = false
        }
      })
    },
    closeBtn() {
      this.$router.back()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 获取余额
    getSum() {
      balanceSum().then(res => {
        if (this.addObj.actype === 'F$') {
          this.balance = res.data.canUseF$ || 0
          this.rateToUsd = res.data.rateToUsd
        } else
          if (this.addObj.actype === 'H0') {
          this.balance = res.data.canUseH0 || 0
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
